/**
 * Canal éditeur du bloc Onglets : la sidebar demande au canvas d'ouvrir un
 * onglet (l'œil d'aperçu d'un item de la liste). L'onglet affiché est un état
 * local du canvas, pas une prop persistée — même approche que le canal
 * d'aperçu des slides (utils/carouselSlidesRegistry.js) et des volets
 * (utils/accordionPanelsRegistry.js).
 *
 * Registre module par instance de rendu : l'iframe de l'éditeur et le viewer
 * ont chacun leur bundle, donc leur propre Set.
 */

const listeners = new Set();

/**
 * @param {(blockId: string, tabId: string) => void} listener
 * @returns {() => void} désabonnement
 */
export function subscribeTabPreview(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyTabPreview(blockId, tabId) {
  listeners.forEach((listener) => listener(blockId, tabId));
}
